import {mapGetters} from 'vuex';

export default {
  name: 'cache',
  computed: {
    ...mapGetters({
      cachedViews: 'tags/cachedViews',
      closedViews: 'tags/closedViews',
    }),
  },
};
